export default "__VITE_ASSET__BDjBs3x2__"